class FeaturesVideoSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.fv-videos__track');
    this.slides = Array.from(el.querySelectorAll('.fv-video-slide'));
    this.dots = Array.from(el.querySelectorAll('.fv-videos__dot'));
    this.prevBtn = el.querySelector('.fv-videos__arrow--prev');
    this.nextBtn = el.querySelector('.fv-videos__arrow--next');
    this.currentIndex = 0;

    if (!this.track || this.slides.length === 0) return;

    this.bindDots();
    this.bindArrows();
    this.bindDrag();
    this.observeVisibility();
  }

  bindDots() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        this.scrollToSlide(index);
      });
    });
  }

  bindArrows() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.scrollToSlide(Math.max(this.currentIndex - 1, 0));
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.scrollToSlide(Math.min(this.currentIndex + 1, this.slides.length - 1));
      });
    }
  }

  scrollToSlide(index) {
    const target = this.slides[index];
    if (target) {
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  bindDrag() {
    let isDown = false;
    let startX = 0;
    let scrollStart = 0;

    this.track.addEventListener('mousedown', (e) => {
      isDown = true;
      this.track.classList.add('is-dragging');
      startX = e.pageX;
      scrollStart = this.track.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      this.track.classList.remove('is-dragging');
    });

    this.track.addEventListener('mouseleave', () => {
      if (!isDown) return;
      isDown = false;
      this.track.classList.remove('is-dragging');
    });

    this.track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.pageX - startX;
      this.track.scrollLeft = scrollStart - dx;
    });
  }

  observeVisibility() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const slide = entry.target;
          const video = slide.querySelector('video');
          const index = parseInt(slide.dataset.slideIndex, 10);

          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            if (video && video.paused) {
              video.play().catch(() => {});
            }
            this.dots.forEach((d) => d.classList.remove('is-active'));
            if (this.dots[index]) this.dots[index].classList.add('is-active');
            this.currentIndex = index;
          } else {
            if (video && !video.paused) {
              video.pause();
            }
          }
        });
      },
      {
        root: this.track,
        threshold: [0, 0.6, 1]
      }
    );

    this.slides.forEach((slide) => observer.observe(slide));
  }
}

document.querySelectorAll('.fv-videos__slider').forEach((el) => new FeaturesVideoSlider(el));
